export default "__VITE_ASSET__DyFwxpWz__"